import { defineStore } from "pinia";
import LanguageService from '@/service/LanguageService'
export const langWeb = defineStore({
  id: "langWeb",
  state: () => ({
    lang: localStorage.language ? localStorage.language : "vi",
  }),
  actions: {
    changeLanguage(lang) {
      this.lang = lang;
    },
    changeLangVI() {
      this.lang = "vi";
      window.localStorage.setItem("language", "vi");
      LanguageService.lang = LanguageService[this.lang.toLocaleUpperCase()];
      console.log("set ngôn ngữ vi");
    },
    changeLangEN() {
      this.lang = "en";
      window.localStorage.setItem("language", "en");
      LanguageService.lang = LanguageService[this.lang.toLocaleUpperCase()];
      console.log("set ngôn ngữ en");
    },
  },
  getters: {
    showLang: (state) => {
      if (state.lang == "vi") return "vi";
      return "en";
    },
  },
});
